import { render, staticRenderFns } from "./WPInputLabel.vue?vue&type=template&id=60602aea"
import script from "./WPInputLabel.vue?vue&type=script&lang=ts"
export * from "./WPInputLabel.vue?vue&type=script&lang=ts"
import style0 from "./WPInputLabel.vue?vue&type=style&index=0&id=60602aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports